module.exports = __webpack_public_path__ + "img/hobbsp.3bc8f5a1.jpg";